import { Link } from "react-router-dom";
import { MapPin, ChevronRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { CtaBand } from "../components/CtaBand";
import { QC_SERVICES_FR, QC_CITIES, qcCityPath } from "../data/quebec";

export default function QuebecServices() {
  return (
    <div data-testid="qc-services-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-8">
      <Seo
        title="Nos Services de Sécurité | 1st Nations Security Québec"
        description="Gardiennage, patrouille mobile, sécurité de chantier, sécurité événementielle, prévention des pertes, surveillance incendie 24/7 et plus au Québec. +1 807-770-0243."
        path="/qc/services-de-securite"
        lang="fr-CA"
      />
      <nav className="text-xs text-slate-500 mb-6 flex items-center gap-1.5">
        <Link to="/qc" className="hover:text-amber-300">Accueil</Link>
        <ChevronRight className="h-3 w-3" />
        <span className="text-slate-300">Services de sécurité</span>
      </nav>
      <h1 className="text-4xl sm:text-5xl font-black tracking-tight text-white font-heading mb-6">
        Nos Services de Sécurité
      </h1>
      <p className="text-base text-slate-300 leading-relaxed max-w-3xl mb-12">
        1st Nations Security offre une gamme complète de services de sécurité professionnels au Québec et en Ontario.
        Tous nos services sont assurés par des agents licenciés, appuyés par notre centre de répartition 24/7.
      </p>
      <div className="space-y-5 max-w-4xl">
        {QC_SERVICES_FR.map((s) => (
          <section key={s.enSlug} id={s.enSlug} data-testid={`qc-service-${s.enSlug}`} className="rounded-2xl border border-white/10 bg-slate-900/60 p-6">
            <h2 className="text-xl font-semibold text-white mb-2">{s.name}</h2>
            <p className="text-sm text-slate-400 leading-relaxed mb-3">{s.desc}</p>
            <Link to={`/security-services/${s.enSlug}`} data-testid={`qc-service-en-link-${s.enSlug}`} className="inline-flex items-center gap-1.5 text-xs font-semibold text-amber-400 hover:text-amber-300">
              Détails complets (anglais) <ChevronRight className="h-3.5 w-3.5" />
            </Link>
          </section>
        ))}
      </div>

      <section data-testid="qc-services-cities-section" className="mt-16">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-white font-heading mb-6">
          Villes Desservies au Québec
        </h2>
        <div className="flex flex-wrap gap-3">
          {QC_CITIES.map((c) => (
            <Link
              key={c.slug}
              to={qcCityPath(c)}
              data-testid={`qc-services-city-link-${c.slug}`}
              className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-slate-950/70 px-4 py-2 text-sm text-slate-300 transition-colors hover:border-amber-500/40 hover:text-amber-300"
            >
              <MapPin className="h-3.5 w-3.5 text-amber-500" /> Sécurité à {c.name}
            </Link>
          ))}
        </div>
      </section>

      <CtaBand
        heading="Parlons de vos besoins en sécurité"
        sub="Appelez le +1 807-770-0243 ou écrivez à admin@1stnation-security.com — service en français et en anglais, 24 heures sur 24."
      />
    </div>
  );
}
